/**
 * /tenants/$slug/directory/ad-inbound — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  adInboundListSearchSchema,
  type AdInboundListSearch,
} from "@/features/directory/ad-inbound-list-search";
import { fetchAdInboundDirectories } from "@/features/directory/queries";
import { queryKeys } from "@/lib/query-keys";
import { AdInboundDirectoriesPage } from "@/features/directory/pages/ad-inbound-directories-page";

export const Route = createFileRoute("/_authed/tenants/$slug/directory/ad-inbound/")({
  validateSearch: (raw: Record<string, unknown>): AdInboundListSearch =>
    adInboundListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ offset: search.offset ?? 0 }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.directory.adInbound.list(context.tenant.id, deps.offset),
      queryFn: () => fetchAdInboundDirectories(context.tenant.id, deps.offset),
    }),
  component: AdInboundDirectoriesPage,
});
